import React, { ReactNode } from 'react';

import ExportTableData from '@shared/components/ExportTableData/ExportTableData';
import PageView from '@shared/components/PageView';
import TableView from '@shared/components/table/TableView';

import type { ColumnSearch, TableHeader } from '@shared/components/table/types';
import type { UsePaginatedReportReturn } from '@shared/hooks/usePaginatedReport';

export type ReportPageLayoutProps = {
  title: string;
  description?: string;
  exportFileName: string;
  formatDataToExport: (dataSet: unknown[]) => Record<string, unknown>[];
  headers: TableHeader[];
  columnsSearch: ColumnSearch[];
  report: UsePaginatedReportReturn;
  mapRowData?: (row: unknown) => Record<string, unknown> & { actions?: ReactNode };
  titleActions?: ReactNode;
};


const ReportPageLayout: React.FC<ReportPageLayoutProps> = ({
  title,
  description,
  exportFileName,
  formatDataToExport,
  headers,
  columnsSearch,
  report,
  mapRowData = (row) => row as Record<string, unknown> & { actions?: ReactNode },
  titleActions,
}) => {
  const { data, isLoading, totalCount, currentPage, nextPage, handleSortingChange, getExportData } = report;

  return (
    <PageView title={title} description={description}>
      <PageView.Actions>
        {titleActions}
        <ExportTableData getData={getExportData(formatDataToExport)} fileName={exportFileName} />
      </PageView.Actions>
      <PageView.Content>
        <TableView
          isLoading={isLoading}
          pagination={{
            pageNumber: currentPage,
            handleChangePage: nextPage,
            handleChangeRowsPerPage: nextPage,
            rowsTotalCount: Number(totalCount),
          }}
          columnsSearch={columnsSearch}
          headers={headers}
          rows={data}
          mapRowData={mapRowData}
          onSortingChange={handleSortingChange}
        />
      </PageView.Content>
    </PageView>
  );
};

export default ReportPageLayout;
